import React, {ReactElement, useEffect, useMemo} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {GridRowClickEvent} from "@progress/kendo-react-grid/dist/npm/interfaces/events";
import {CustomButton, GridField} from "ndr-designsystem";
import {setTenants} from "../store/TenantsSlice"
import {useAppDispatch, useAppSelector} from "../../../app/hooks"
import {fetchTenants} from "../store/Thunks"
import {setCurrentPage} from "../../appStateSlice";

const TenantsList: React.FC<{}> = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const { t } = useTranslation('tabels');
    const { tenants } = useAppSelector(state => state.Tenants);

    useEffect(() => {
        dispatch(setCurrentPage("tenants_list"))
    }, [t, dispatch])

    // Load once; paging is handled client-side by the grid, so page changes don't refetch
    useEffect(() => {
        dispatch(fetchTenants());
    }, [dispatch])

    const forceRefresh = (): void => {
        dispatch(setTenants(undefined));
        dispatch(fetchTenants());
    }

    const onRowClick = (e: GridRowClickEvent): void => {
        history.push(`/tenants/${e.dataItem.inventoryItemId}`);
    }
    const handleAddTenant = (): void => {
        history.push(`/tenants/add`);
    }

    const CustomToolbar = (): ReactElement => (
        <div>
            <CustomButton variant="contained" title={t('tenantsList.add_new')} color="primary" onClick={handleAddTenant} />
        </div>
    );

    const gridFields = useMemo(() => [
        {
            title: "ID",
            name: "inventoryItemId"
        },
        {
            title: t('tenantsList.name'),
            name: "name"
        },
        {
            title: t('tenantsList.marketPartnerIDCode'),
            name: "marketPartnerIDCode"
        },
        {
            title: t('tenantsList.marketPartnerIDEncoding'),
            name: "marketPartnerIDEncoding"
        },
        {
            title: t('tenantsList.NumberOfControllableResources'),
            name: "controllableResourcesCount"
        },
        {
            title: t('tenantsList.NumberOfReceivedActivations'),
            name: "activationsCount"
        }
    ], [t]);

    return (
        <div>
            <GridField
                customToolbar={<CustomToolbar />}
                addButtonText="true"
                totalItems={tenants?.length}
                values={tenants ?? []}
                noRecordsText={tenants === undefined ? "" : t('tabels:no_records_text')}
                gridFields={gridFields}
                onRefresh={forceRefresh}
                onAddNew={handleAddTenant}
                onRowClick={onRowClick}
                dataItemKey="inventoryItemId"
                defaultOpen
            />
        </div>
    )
}


export default TenantsList
